{
  "title": "Nie mogliśmy znaleźć strony",
  "body": "Proszę sprawdzić, czy podany adres URL jest poprawny i spróbować ponownie"
}
